// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"9f36b01b","500":"c11b517e","541":"e5d9cd3e"}[chunkId] + ".chunk.css";
};